<div class="int-guide">
    <div class="notifi-box">
        <ng-content></ng-content>
    </div>
    <img src="/assets/help-user.svg" alt="" height="284">
</div>